/* eslint-disable */

export enum FormType {
	Unknown = 0,
	Claims = 1,
	Returns = 2,
	Payment = 3,
	Changes = 4,
	Deliveries = 5,
	OtherQuestions = 6,
	ShippingDamage = 7,
	QuoteRequest = 8,
	ProductQuestion = 9,
	PriceMatch = 10,
	PriceMatchExistingOrder = 11,
	OrderManagement = 12,
	PaymentBilling = 13,
	General = 14,
	ShippingAndDelivery = 15,
	ReturnAndExchange = 16,
	SalesAndOffer = 17,
	ZendeskClaims = 18,
	
}
